// src/pages/NovaPropostaPage.jsx - MIGRAÇÃO PARA NOVO SISTEMA
import React from 'react';
import { ExternalLink, AlertTriangle, ArrowRight, KeyRound } from 'lucide-react';
import Header from '../components/common/Header';
import Navigation from '../components/common/Navigation';
import './NovaPropostaPage.css';

const NovaPropostaPage = () => {
  return (
    <div className="page-container">
      <div className="container">
        <Header title="Nova Proposta" />
        <Navigation />

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh',
          padding: '2rem'
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 165, 0, 0.3)',
            borderRadius: '16px',
            padding: '3rem',
            maxWidth: '600px',
            width: '100%',
            textAlign: 'center'
          }}>
            <AlertTriangle size={48} style={{ color: '#FFA500', marginBottom: '1.5rem' }} />

            <h2 style={{ color: '#fff', marginBottom: '1rem', fontSize: '1.5rem' }}>
              Sistema em Migração
            </h2>

            <p style={{ color: '#ccc', marginBottom: '1.5rem', lineHeight: '1.6' }}>
              A criação de novas propostas foi migrada para o novo sistema.
              Utilize este sistema apenas para acompanhar propostas que ainda estão em aberto
              e não foram migradas.
            </p>

            <div style={{
              background: 'rgba(0, 150, 255, 0.1)',
              border: '1px solid rgba(0, 150, 255, 0.3)',
              borderRadius: '12px',
              padding: '1.5rem',
              marginBottom: '1.5rem'
            }}>
              <p style={{ color: '#aadcff', marginBottom: '0.75rem', fontWeight: 'bold' }}>
                Para criar novas propostas, acesse:
              </p>
              <a
                href="https://nexus.aupusenergia.com.br/crm/propostas"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  background: '#0066cc',
                  color: '#fff',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  transition: 'background 0.2s'
                }}
              >
                <ExternalLink size={18} />
                Acessar Novo Sistema
                <ArrowRight size={18} />
              </a>
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '10px',
              padding: '1.25rem',
              textAlign: 'left'
            }}>
              <p style={{ color: '#aaa', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <KeyRound size={16} />
                <strong style={{ color: '#ddd' }}>Dados de acesso:</strong>
              </p>
              <p style={{ color: '#ccc', margin: '0.25rem 0', paddingLeft: '1.5rem' }}>
                <strong>Login:</strong> seu e-mail atual
              </p>
              <p style={{ color: '#ccc', margin: '0.25rem 0', paddingLeft: '1.5rem' }}>
                <strong>Senha inicial:</strong> <code style={{ background: 'rgba(255,255,255,0.1)', padding: '2px 6px', borderRadius: '4px' }}>@Aupus123</code>
              </p>
              <p style={{ color: '#f0ad4e', margin: '0.5rem 0 0', paddingLeft: '1.5rem', fontSize: '0.85rem' }}>
                Altere sua senha no primeiro acesso.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NovaPropostaPage;
